module.exports = __webpack_public_path__ + "img/vod_logo.639c60f2.svg";